import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { CheckoutLayout } from '../../components/checkout/CheckoutLayout'
import { isAuthed } from '../../utils/jwt'

const PATH = '/bookings'

export const Route = createFileRoute(PATH)({
    ssr: false,
    beforeLoad: ({ location }) => {
        if (!isAuthed()) {
            throw redirect({ to: '/login', search: { redirect: location.href } })
        }
    },
    component: () => (
        <CheckoutLayout>
            <Outlet />
        </CheckoutLayout>
    ),
})
